// extracted by mini-css-extract-plugin
export var logo = "_4y-2";
export var logoWrapper = "_4y-1";
export var strip = "_4y-0";